// ======================================================================
// File Name       : userHistoryCourse
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/userHistoryCourse';

export function doInitSearchInput(initData) {
  return {
    type: ActionTypes.USER_HISTORY_COURSE_INIT_SEARCH_INPUT,
    initData,
  };
}

export function doReceivedSearchResult(courseList, courseStatus, recordNum) {
  return {
    type: ActionTypes.USER_HISTORY_COURSE_RECEIVED_SEARCH_RESULT,
    courseList,
    courseStatus,
    recordNum,
  };
}

export function doReceivedUserHistoryCourseDetail(isExist, courseDetail, userGroupBySecernId) {
  return {
    type: ActionTypes.USER_HISTORY_COURSE_RECEIVED_COURSE_DETAIL,
    isExist,
    courseDetail,
    userGroupBySecernId,
  };
}

// #7386 START
export function doReceivedPieChartData(data) {
  return {
    type: ActionTypes.USER_HISTORY_COURSE_RECEIVED_PIE_CHART_DATA,
    data,
  };
}

export function doReceivedBarChartData(data) {
  return {
    type: ActionTypes.USER_HISTORY_COURSE_RECEIVED_BAR_CHART_DATA,
    data,
  };
}
// #7386 END